module.exports = __webpack_public_path__ + "img/pin-red.6169ae6c.svg";